import { useState } from 'react';
import { createOrganisation } from '../api';
import { useAuth } from '../context/AuthContext';

export default function AddOrganisationPage() {
  const [name, setName] = useState('');
  const [slug, setSlug] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { addOrgAssignment } = useAuth();

  const handleNameChange = (e) => {
    const val = e.target.value;
    setName(val);
    setSlug(val.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);
    try {
      const data = await createOrganisation({ name, slug });
      addOrgAssignment({
        organisationId: data.id,
        organisationName: data.name,
        profileName: 'Admin',
      });
      setMessage(`Organisation "${data.name}" created successfully`);
      setName('');
      setSlug('');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <div className="form-card">
        <h2>Add Organisation</h2>
        {error && <div className="alert alert-error">{error}</div>}
        {message && <div className="alert alert-success">{message}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Organisation Name</label>
            <input
              type="text"
              value={name}
              onChange={handleNameChange}
              required
              placeholder="Acme Labs"
            />
          </div>
          <div className="form-group">
            <label>Slug</label>
            <input
              type="text"
              value={slug}
              onChange={(e) => setSlug(e.target.value)}
              required
              placeholder="acme-labs"
            />
            <small>URL-friendly identifier, auto-generated from name</small>
          </div>
          <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
            {loading ? 'Creating...' : 'Create Organisation'}
          </button>
        </form>
      </div>
    </div>
  );
}
